
globalThis.ColorPreviewer = (function() {
  function ColorPreviewer($html) {
    this.$html = $html;
    this.$input = this.$html.find('*[data-target="color-previewer.input"]');
    this.$preview = this.$html.find('*[data-target="color-previewer.preview"]');

    this.init();
  }

  ColorPreviewer.init = function($ctx) {
    ($ctx || $('body')).find('*[data-sb-controller="color-previewer"]').each(function() {
      new ColorPreviewer($(this));
    });
  }

  ColorPreviewer.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var moduleInstance = this;

      this.$input.on('change keyup', function() {
        moduleInstance.$preview.css('background-color', moduleInstance.$input.val());
      });
    }
  }

  return ColorPreviewer;
})();
